export default __webpack_public_path__ + "static/media/dzone.c98b4d5a.png";